/**
 * @generated SignedSource<<c35fc4abaf96d309096c324cc5d2cb6c>>
 * @relayHash 84c3ba93abd4f2ee8463a745ed29f5df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 45d635a9c83dc83e2ff0caa88823c1867947118b89fa4fd720a44020c9a12ab8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "45d635a9c83dc83e2ff0caa88823c1867947118b89fa4fd720a44020c9a12ab8",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
